// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateClosingAccountChangesIndex = (state, action) => action.accountIndex;

export default (state = getWipDefaultState().closingAccountIndex, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_CLOSING_ACCOUNT_INDEX]: updateClosingAccountChangesIndex
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/closing-account-index.js